import { useCallback } from "react";
import { useApiMutation } from "../../useApiMutation";

interface SubscriptionInput {
    subscriptionId: string;
    isSubscribed: boolean;
}

const useUpdateSubscription = () => {
    const { mutate, isLoading, error, reset } = useApiMutation<SubscriptionInput>("/per_person_subscriptions", {
        method: "PATCH",
        headers: { "Content-Type": "application/merge-patch+json" },
        buildEndpoint: ({ subscriptionId }) => `/per_person_subscriptions/${subscriptionId}`,
        buildBody: ({ isSubscribed }) => JSON.stringify({ isSubscribed: isSubscribed ? 1 : 0 }),
    });

    const updateSubscription = useCallback(
        (subscriptionId: string, isSubscribed: boolean) => mutate({ subscriptionId, isSubscribed }),
        [mutate]
    );

    return { updateSubscription, isLoading, error, reset };
};

export default useUpdateSubscription;
